import { useQuery } from '@tanstack/react-query';
import { amsPublicApiAccountsGetOwnAccountDetail } from 'service/amsApi';
import { AmsApiError } from 'components/AdminSettings/amsApiError';
import { isAmsAuthActive } from 'service/amsSession';

const MULTIPLE_WORKSPACES_CONFIG_KEY = 'multiple_workspaces';

export type WorkspaceMode = 'single' | 'multi' | 'unknown' | 'error';

export function useWorkspaceMode(): WorkspaceMode {
  const { account, loading, error } = useAccountDetail();

  if (error) { return 'error'; }
  if (loading || !account) { return 'unknown'; }
  const multiple = account.config.some(
    (field) => field.key === MULTIPLE_WORKSPACES_CONFIG_KEY && field.value === true,
  );
  return multiple ? 'multi' : 'single';
}

export function useAccountDetail() {
  const enabled = isAmsAuthActive();

  const { data, isLoading, error } = useQuery({
    queryKey: ['account'],
    queryFn: async () => {
      try {
        const { data, error } = await amsPublicApiAccountsGetOwnAccountDetail();
        if (error) {
          throw new AmsApiError(error);
        }
        if (typeof data !== 'object' || data === null || Array.isArray(data)) {
          throw new Error('Account detail response was not a valid object');
        }
        return data;
      } catch (loadError) {
        if (!(loadError instanceof AmsApiError && loadError.code === 'account_not_provisioned')) {
          console.error('account detail load failed', loadError);
        }
        throw loadError;
      }
    },
    enabled,
    retry: false,
  });

  return { account: data, loading: isLoading, error };
}
